import { render } from "./PostPassportTable.vue?vue&type=template&id=ed02f586&scoped=true"
import script from "./PostPassportTable.vue?vue&type=script&lang=js"
export * from "./PostPassportTable.vue?vue&type=script&lang=js"

import "@/assets/table.css?vue&type=style&index=0&id=ed02f586&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed02f586"]])

export default __exports__